import { render, staticRenderFns } from "./RdpGatewayHistory.vue?vue&type=template&id=5903e712"
import script from "@/scripts/gpuHub/rdpGateway/rdpGatewayHistory.js?vue&type=script&lang=js&external"
export * from "@/scripts/gpuHub/rdpGateway/rdpGatewayHistory.js?vue&type=script&lang=js&external"
import style0 from "./RdpGatewayHistory.vue?vue&type=style&index=0&id=5903e712&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports